module.exports = __webpack_public_path__ + "assets/img/home2-box2-6.05e329c4.png";